import {
  Card,
  DividerHorizontal,
  TextHeading3,
  token,
} from '@angeplus/prever-component-lib';
import styled from '@emotion/styled';
import { ReactNode } from 'react';
import PlanItem from '../../catalog/PlanItem';
import { BenefitsStatus, getBenefitsStatus } from './getBenefitsStatus';

export type BenefitsItem = {
  description: string;
  status: BenefitsStatus;
};

type BenefitsCardProps = {
  image: string;
  title: string;
  items: BenefitsItem[];
  footer: ReactNode;
};

export const BenefitsCard = (props: BenefitsCardProps) => {
  return (
    <Card>
      <Image alt="" src={props.image} />
      <TextHeading3>{props.title}</TextHeading3>
      {props.items.map((item, index) => {
        return (
          <PlanItem
            key={index}
            label={item.description}
            icon={getBenefitsStatus(item.status)}
          />
        );
      })}
      <DividerHorizontal />
      {props.footer}
    </Card>
  );
};

const Image = styled.img`
  margin: -${token.spacing.spacingSmall};
  margin-bottom: 0;
  width: calc(100% + ${token.spacing.spacingLarge});
  height: 277px;
  border-radius: 8px 8px 0px 0px;
  object-fit: cover;
`;
